import React from 'react';
import {
	SypacVerticalTimeline,
	SypacVerticalTimelineStep,
} from '@sypac/component-library-react';
import Default from '../../../../../../components/Notification/Default';
import { useTranslate } from '@tolgee/react';

interface OrderAcceptedProps {
	notification: boolean;
	date: string;
}
const NotificationOrderAccepted = ({
	notification,
	date,
}: OrderAcceptedProps) => {
	const { t } = useTranslate();

	return (
		<div className="flex flex-row gap-6">
			<SypacVerticalTimeline>
				<SypacVerticalTimelineStep isActive={notification} minWidth={98}>
					{date}
				</SypacVerticalTimelineStep>
			</SypacVerticalTimeline>
			<div className="h-fit w-full">
				<Default
					notification={notification}
					title={t('notificationOrderAccepted.orderAccepted', 'Order accepted')}
					description={t(
						'notificationOrderAccepted.awaitingTruckAllocation',
						'Awaiting truck allocation.',
					)}
				/>
			</div>
		</div>
	);
};

export default NotificationOrderAccepted;
